import { render, staticRenderFns } from "./radarBoard.vue?vue&type=template&id=45fad212&scoped=true&"
import script from "./radarBoard.vue?vue&type=script&lang=ts&"
export * from "./radarBoard.vue?vue&type=script&lang=ts&"
import style0 from "./radarBoard.vue?vue&type=style&index=0&id=45fad212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fad212",
  null
  
)

export default component.exports